export type EtaiementScopeMatrixRowDef = {
  id: string;
  label: string;
};

export type EtaiementScopeMatrixSectionDef = {
  id: string;
  label: string;
  rows: EtaiementScopeMatrixRowDef[];
};

export const ETAIEMENT_SCOPE_MATRIX = {
  title: 'ETAIEMENTS ET COFFRAGES DES DALLES',
  columns: {
    lvtec: 'LV TEC',
    eiffage: 'CLIENT',
  },
  sections: [
    {
      id: 'production',
      label: 'PRODUCTION',
      rows: [
        { id: 'fiche-autocontrole-avant-coulage', label: 'Fiche Autocontrôle Avant Chaque Coulage' },
        { id: 'tracage-axes-niveaux-controle-altimetries', label: 'Traçage des axes et des niveaux de référence et contrôle altimétries' },
        { id: 'fourniture-mise-en-place-arrets-coulage', label: 'Fourniture et mise en place des arrêts de coulage' },
        { id: 'coffrages-rives-option', label: 'Les coffrages de rives (à convenir en option)' },
        { id: 'huilage-etancheite-coffrages', label: 'Huilage/ étanchéité des coffrages' },
      ],
    },
    {
      id: 'manutention',
      label: 'MANUTENTION',
      rows: [
        { id: 'manutention-verticale-chef-manoeuvre', label: 'Manutention verticale chef de manœuvre' },
      ],
    },
  ] satisfies EtaiementScopeMatrixSectionDef[],
};

export const ETAIEMENT_SCOPE_MATRIX_ROW_IDS = ETAIEMENT_SCOPE_MATRIX.sections.flatMap(
  (section) => section.rows.map((row) => row.id),
);
